import { render, staticRenderFns } from "./color-light.vue?vue&type=template&id=5da75f82"
import script from "./color-light.ts?vue&type=script&lang=js&external"
export * from "./color-light.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports